import {
  highlightFirstVideo,
  highlightFourthVideo,
  highlightSecondVideo,
  highlightThirdVideo,
} from "../utils";


export const navLists = [
  "About",
  "Projects",
  "Experience",
  "Contact",
  "Resume",
  "Reel",
];

export const highlightsSlides = [
  {
    id: 1,
    textLists: [
      "AI Based GIS scripts.",
      "Landslides Predictions.",
    ],
    video: highlightFirstVideo,
    videoDuration: 4,
  },
  {
    id: 2,
    textLists: [
      "Custom Stable Diffusion Models.", "Image Reconstruction.",
    ],
    video: highlightSecondVideo,
    videoDuration: 5,
  },
  {
    id: 3,
    textLists: [
      "Blender Projects."
    ],
    video: highlightThirdVideo,
    videoDuration: 2,
  },
  {
    id: 4,
    textLists: ["Research Simulations."],
    video: highlightFourthVideo,
    videoDuration: 3.63,
  },
];

export const EXPERIENCES = [
  {
    year: "Jan 2026 - Feb 2026.",
    role: "Sports Data Analyst",
    company: "NeuralPort japan 🇯🇵",
    description: `Built a high-performance, ML-ready eye-tracking analytics pipeline and brain-fatigue scoring framework, validating mindfulness and sauna interventions through rigorous statistical analysis, optimized visualizations, and production-ready metrics integrated with VR-based web applications.`,
    technologies: ["Python", "Pytorch", "Numpy", "Git / Github", "seaborn / Matplotlib", "Potly"],
  },
  {
    year: "Oct 2021 - Sept 2025.",
    role: "Simulation Engineer",
    company: "Botlab Dynamics",
    description: `Onboarded as a Simulation Engineer, I've been responsible for developing and maintaining simulation models for various projects. I've collaborated with cross-functional teams to ensure the accuracy of simulation models and to provide insights into the performance of the system. I've also developed tools to automate the simulation process, reducing the time required to generate results by 50%.`,
    technologies: ["Blender", "Python", "3D", "Instant Meshes", "Git", "bpy Module"],
  },
  {
    year: "Nov 2023 - April 2024",
    role: "Internship - Project Lead",
    company: "Petra Oil Bitumen.",
    description: `I was responsible for leading a team of 5 developers to develop a web application for managing the company's inventory. I worked closely with the product owner to define the project scope and requirements, and managed the development process from start to finish. I also conducted code reviews and provided technical guidance to the team to ensure the quality of the codebase.`,
    technologies: ["Flask", "Python", "MongoDB", "ReactJs", "AWS"],
  },
  {
    year: "June 2020 - April 2021",
    role: "Photorealistic Concept Generation Artist",
    company: "StarProd Events.",
    description: `Collaborated with Starprod Events to create photorealistic 3D renders for high-profile international clients, significantly enhancing the event planning pipeline. This partnership led to an 85% increase in client approval rates and a 60% reduction in revision cycles. Worked on notable projects including Huawei’s virtual marketing strategy during COVID, Peugeot’s 3D projection-based car unveiling, and Estēe Lauder’s ballroom event visualization. Delivered high-impact visuals for business expos and corporate events.`,
    technologies: ["Blender", "Photoshop", "3D Rendering", "Lighting Design", "Client Communication"],
  },
];



export const HERO_CONTENT = `I am a Passionate Artificial Intelligence Engineer and Github Contributor with a demonstrated history of working in the services industry. Skilled in Python, Machine Learning, Deep Learning and Blender. Strong engineering professional with a Bachelor of Technology Degree in Aritificial intellegence and Data Science. Led large-scale drone show simulations and built advanced web scraping tools. Published researcher. Passionate about building intelligent, real-world solutions.`;
